<div class="container" *ngIf="this.gradientConfig.layout === 'horizontal' && this.gradientConfig.subLayout === 'horizontal-2'; else mainHeader">
  <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
</div>
<ng-template #mainHeader >
  <div class="m-header">
    <!--<a href="javascript:" class="mobile-menu" id="mobile-collapse" (click)="navCollapse()"><span></span></a>-->
    <a [routerLink]="['/home']" class="b-brand">
      <img id="main-logo" src="assets/images/logo/logo.png" alt="" class="logo" width="80%">
      <img id="main-logo" src="assets/images/logo/logoPreto.png" alt="" class="logo logoMobileNovo" width="70%">
    </a>
    <a class="mob-toggler" [ngClass]="{'on' : this.menuClass}" href="javascript:" (click)="toggleMobOption()"><i class="feather icon-menu"></i></a>
  </div>
  <div class="collapse navbar-collapse" [style.display]="this.collapseStyle">
    <app-nav-left class="mr-auto"></app-nav-left>
    <app-nav-right class="ml-auto"></app-nav-right>
    <a class="d-mobile" [ngClass]="{'on' : this.menuClass}" href="javascript:" (click)="toggleMobOption()"><i class="feather icon-x-circle"></i></a>
  </div>
</ng-template>
